export default __webpack_public_path__ + "static/media/categoryname2.12a3dbe2.png";